export const videoTypes = {
    loading: "LOADING_VIDEO",
    delete: "DELETE_VIDEO",
    loadedOne: "LOADED_VIDEO",
    loadedMultiple: "LOADED_VIDEOS",
    success: "SUCCESS_VIDEO",
    restore: "RESTORE_VIDEO",
    hardDelete: "HARDDELETE_VIDEO",
};
